/**
 * Partidas de referencia para el presupuesto de obra.
 *
 * Los precios unitarios son REFERENCIALES (obra negra y acabados de una casa
 * habitación de nivel medio, zona metropolitana del norte de México, 2026) y
 * se pueden editar. `ratio` es la cantidad por m² construido. Revisar con
 * cotizaciones locales antes de usarlos como presupuesto real.
 */
export const OBRA_REVISADO = "2026-10";

export const PARTIDAS_OBRA = [
  { id: "trazo", nombre: "Limpieza, trazo y nivelación", unidad: "m²", ratio: 1, precio: 35 },
  { id: "excavacion", nombre: "Excavación para cimentación", unidad: "m³", ratio: 0.3, precio: 320 },
  { id: "cimentacion", nombre: "Cimentación (zapata corrida y dala de desplante)", unidad: "m", ratio: 0.9, precio: 1650 },
  { id: "firme", nombre: "Firme de concreto de 10 cm", unidad: "m²", ratio: 0.9, precio: 420 },
  { id: "block", nombre: "Muro de block de 15 cm pegado (block, mortero y mano de obra)", unidad: "m²", ratio: 2.2, precio: 520 },
  { id: "castillos", nombre: "Castillos y cadenas de cerramiento", unidad: "m", ratio: 1.8, precio: 380 },
  { id: "losa", nombre: "Losa de concreto armado de 10 cm", unidad: "m²", ratio: 1, precio: 1350 },
  { id: "aplanado", nombre: "Aplanado de mezcla en muros", unidad: "m²", ratio: 4, precio: 190 },
  { id: "pisos", nombre: "Piso cerámico colocado", unidad: "m²", ratio: 0.85, precio: 480 },
  { id: "hidro", nombre: "Instalación hidrosanitaria", unidad: "salida", ratio: 0.25, precio: 1800 },
  { id: "electrica", nombre: "Instalación eléctrica", unidad: "salida", ratio: 0.6, precio: 750 },
  { id: "pintura", nombre: "Pintura vinílica", unidad: "m²", ratio: 4, precio: 85 },
  { id: "herreria", nombre: "Puertas, ventanas y herrería", unidad: "m²", ratio: 0.15, precio: 3500 },
];
